import './style.css';
import { Game } from './game';
import { CAST_ANIMS } from './data/skill-anims';
import { classStatsFor } from './sim/meta';
import { beginTask, setProgress } from './ui/loading';
import type { MetaState } from './sim/meta';
import type { ClassId } from './sim/types';

declare global {
  interface Window {
    /** Dùng cho kiểm thử tự động bằng Playwright: window.__TDK__ */
    __TDK__?: Game;
    /** số liệu hiệu năng do scene cập nhật */
    __TDK_PERF__?: Record<string, number>;
    /** bảng dáng ra chiêu (data/skill-anims.ts) */
    __TDK_ANIMS__?: Record<string, unknown>;
    /**
     * Tính chỉ số của 1 CLASS theo meta HIỆN TẠI (v7: sổ tướng đã xoá, chỉ số nay theo class).
     * Dùng cho công cụ kiểm chứng: đo "tập luyện không phụ thuộc màn" bằng số thật
     * (`verify-web.mjs`), không phải bằng cách đọc code.
     */
    __TDK_HERO_STATS__?: (classId: ClassId, meta?: MetaState) => Record<string, number>;
  }
}

/*
 * MÀN CHỜ — ĐĂNG KÝ NGAY KHI MODULE NẠP, TRƯỚC MỌI THỨ KHÁC.
 *
 * ⚠️ VÌ SAO PHẢI Ở ĐÂY, KHÔNG PHẢI TRONG `onBoot()`: khối `#bootLoading` đã hiện sẵn từ HTML, nhưng
 * nếu không đăng ký nguồn chờ nào thì nó sẽ nằm đó MÃI (không ai gọi `hide`). Đăng ký 1 nguồn "boot"
 * ngay tại đây rồi kết thúc khi `Game` boot xong ⇒ màn chờ tự tắt đúng lúc.
 */
const bootDone = beginTask();
setProgress(2);

const game = new Game();
game.onReady(() => {
  // boot xong: nhường 1 nhịp để khung hình đầu của trang chủ vẽ xong rồi mới mờ màn chờ
  window.setTimeout(() => bootDone(), 60);
});
window.__TDK__ = game;
// Bảng dáng ra chiêu — để công cụ kiểm chứng đọc được danh sách dáng thật
window.__TDK_ANIMS__ = CAST_ANIMS;
// đo chỉ số tướng cho công cụ kiểm chứng (xem tools/verify-web.mjs)
window.__TDK_HERO_STATS__ = (classId, meta) => classStatsFor(classId, meta ?? game.meta) as unknown as Record<string, number>;

// cảnh báo sớm nếu trình duyệt không có WebGL
if (!document.createElement('canvas').getContext('webgl') && !document.createElement('canvas').getContext('webgl2')) {
  const warn = document.createElement('div');
  warn.setAttribute(
    'style',
    'position:fixed;inset:0;display:grid;place-items:center;background:#1a1410;color:#f3e7d3;font:16px system-ui;z-index:999;padding:24px;text-align:center',
  );
  warn.innerHTML =
    'Trình duyệt của bạn không bật WebGL, nên game không chạy được.<br/>Hãy bật tăng tốc phần cứng rồi tải lại trang.';
  document.body.appendChild(warn);
}
